export interface PlanChoice {
  [key: string]: unknown;
  id: unknown;
  product_id: unknown;
  code: unknown;
  name: unknown;
  active: unknown;
  display_order?: unknown;
}

export function displayPlanCode(code: unknown): string {
  // Keep API and signed-lease codes unchanged; this is an administrator display label.
  return typeof code === 'string' ? code.toUpperCase() : '—';
}

export function productPlanChoices<T extends PlanChoice>(plans: readonly T[], productId: unknown): T[] {
  return plans.filter((plan) => plan.active === true && plan.product_id === productId);
}

export function replacementPlanChoices<T extends PlanChoice>(
  plans: readonly T[],
  productId: unknown,
  currentPlanId: unknown,
): T[] {
  return plans
    .filter(
      (plan) => plan.active === true && plan.product_id === productId && plan.id !== currentPlanId,
    )
    .toSorted((left, right) => {
      const leftOrder = typeof left.display_order === 'number' ? left.display_order : 1000;
      const rightOrder = typeof right.display_order === 'number' ? right.display_order : 1000;
      if (leftOrder !== rightOrder) return leftOrder - rightOrder;
      return String(left.code).localeCompare(String(right.code));
    });
}

export function attentionMessage(reason: unknown, lastSeenLabel: string): string {
  if (reason === 'NEVER_CHECKED_IN') return 'Never checked in';
  if (reason === 'HEARTBEAT_OVERDUE') return `Heartbeat overdue — last seen ${lastSeenLabel}`;
  return 'Requires review';
}

export interface SubscriptionPbxSource {
  plan_multi_pbx?: unknown;
  multi_pbx_override?: unknown;
  effective_multi_pbx?: unknown;
}

export function subscriptionPbxLimits(source: SubscriptionPbxSource): {
  planDefault: number | null;
  customOverride: number | null;
  effective: number | null;
} {
  const integerOrNull = (value: unknown) =>
    typeof value === 'number' && Number.isSafeInteger(value) && value >= 1 ? value : null;
  return {
    planDefault: integerOrNull(source.plan_multi_pbx),
    customOverride: integerOrNull(source.multi_pbx_override),
    effective: integerOrNull(source.effective_multi_pbx),
  };
}

export function canEditSubscriptionPbxLimit(productCode: unknown, planCode: unknown): boolean {
  return productCode === 'CDRMETRICS' && planCode === 'ENTERPRISE';
}
